import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { bubEvents } from 'javascripts/shared/events/bub_events';
import { graphQL } from 'javascripts/shared/graphql';
import { graphQLMutations } from 'javascripts/shared/graphql/mutations';

import { FadeIn } from 'javascripts/components/fade_in';
import { ChirpButton } from 'javascripts/components/chirp_button';

import likeIcon from 'images/like';

import styles from 'stylesheets/components/reviews/review_likes_section.module';

export function ReviewLikesSection(props) {
  const [likedByCurrentUser, setLikedByCurrentUser] = useState(props.likedByCurrentUser);
  const [likesCount, setLikesCount] = useState(props.likesCount);

  function like() {
    bubEvents.track('Review', 'Click button', {
      label: 'Like review',
      value: props.userReviewId,
    });
    return graphQL.get(graphQLMutations.likeUserReview, { userReviewId: props.userReviewId }).then(() => {
      setLikesCount(likesCount + 1);
      setLikedByCurrentUser(true);
    });
  }

  function unlike() {
    bubEvents.track('Review', 'Click button', {
      label: 'Remove review like',
      value: props.userReviewId,
    });
    return graphQL.get(graphQLMutations.unlikeUserReview, { userReviewId: props.userReviewId }).then(() => {
      setLikesCount(likesCount - 1);
      setLikedByCurrentUser(false);
    });
  }

  function renderButton() {
    return (
      <ChirpButton
        alignIcon='left'
        class={styles.likeButton}
        displayStyle='gray'
        icon={likeIcon}
        iconSize='small'
        label={likedByCurrentUser ? 'Liked' : 'Like'}
        onClick={likedByCurrentUser ? unlike : like}
      />
    );
  }

  function renderLikeText() {
    if (!(likesCount > 0)) {
      return null;
    }
    return <FadeIn className={styles.likeText}>{`${likesCount} reader${likesCount > 1 ? 's' : ''} liked this`}</FadeIn>;
  }

  if (!props.showButton) {
    if (!(likesCount > 0)) {
      return null;
    }
    return <div className={styles.reviewLikes}>{renderLikeText()}</div>;
  }

  return (
    <div className={styles.reviewLikes}>
      <p className={styles.helpfulText}>Find this review helpful?</p>
      <div className={styles.likeButtonSection}>
        {renderButton()}
        {renderLikeText()}
      </div>
    </div>
  );
}

ReviewLikesSection.propTypes = {
  likedByCurrentUser: PropTypes.bool,
  likesCount: PropTypes.number,
  userReviewId: PropTypes.string.isRequired,
  showButton: PropTypes.bool.isRequired,
};

ReviewLikesSection.defaultProps = {
  likedByCurrentUser: false,
  likesCount: 0,
  showButton: false,
};
